@if (dataLoaded) {
  <div class="row">
    <rask-selector
      class="col-2"
      label="Mottagningsplats"
      [(ngModel)]="searchModel.mottagningsplats"
      [viewFormatter]="mottagningsplatsViewFormatter"
      [formatter]="mottagningsplatsSelectedFormatter"
      [values]="mottagningsplatser"
    aid="MottagningsplatsMatinfoRegelverkFilter"></rask-selector>
    <rask-input
      class="col-2"
      label="Inmätningshandelssortiment"
      [(ngModel)]="searchModel.inmatningshandelssortiment"
      aid="InmatningshandelssortimentRegelverkFilter"
    ></rask-input>
    <rask-input
      class="col-2"
      label="Mottagare"
      [(ngModel)]="searchModel.mottagare"
      aid="MottagareAffarsledRegelverkFilter"
    ></rask-input>
    <rask-tree-selector
      class="col-2"
      label="Mo/Ro/Po"
      [items]="searchFilterVerksamhetsOmraden"
      [comparePredicate]="comparePredicate"
      aid="OmradeAffarsledRegelverkFilter"
    ></rask-tree-selector>
    <rask-button
      class="col-4"
      color="secondary"
      aid="filtreraRegelverkviol3"
    (click)="search()">Sök</rask-button>
  </div>
}
<div class="row">
  @if (searchResult) {
    <rask-redovisningshanvisning class="col-12"
      [searchResult]="searchResult"
      >
    </rask-redovisningshanvisning>
  }
</div>


